import { Alert, Snackbar, styled } from '@mui/material';
import { useDispatch } from "react-redux";
import { showPushNotification } from "../../redux/commonSlice";
import { useAppSelector } from "../../store/hooks";
var CustomAlert = styled(Alert)(function (_ref) {
    var theme = _ref.theme;
    return {
        backgroundColor: '#2C68C9',
        color: '#fff'
    };
});
export var PushNotification = function (props) {
    var dispatch = useDispatch();
    var notification = useAppSelector(function (state) { return state.common.pushNotification; });
    var handleClose = function () {
        dispatch(showPushNotification({
            isOpen: false,
            message: notification.message
        }));
    };
    return /*#__PURE__*/ React.createElement(Snackbar, {
        open: notification.isOpen,
        autoHideDuration: 2000,
        anchorOrigin: {
            vertical: 'top',
            horizontal: "right"
        },
        onClose: handleClose
    }, /*#__PURE__*/ React.createElement(CustomAlert, {
        elevation: 20,
        variant: "filled",
        onClose: handleClose
    }, notification.message));
};
